import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatNepaliDate } from '../utils/nepaliDate';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';

function Navbar({ setIsOpen }) {
  const today = formatNepaliDate(new Date());
  const { owner } = useAuth();
  const { isDark, toggle } = useTheme();
  const navigate = useNavigate();

  return (
    <header
      className="px-5 py-3 flex items-center justify-between sticky top-0 z-10 flex-shrink-0"
      style={{
        background: 'var(--navbar-bg)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(0,255,240,0.06)',
      }}
    >
      <div className="flex items-center gap-3">
        <button
          className="lg:hidden w-10 h-10 flex items-center justify-center rounded-xl transition-colors flex-shrink-0"
          style={{ background: 'var(--aqua-dim)', color: 'var(--aqua)', border: '1px solid var(--border)' }}
          onClick={() => setIsOpen(prev => !prev)}
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        <h1 className="text-sm font-semibold hidden sm:block tracking-wide" style={{ color: 'var(--text-muted)' }}>
          GymPro Management
        </h1>
      </div>

      <div className="flex items-center gap-3">
        <span
          className="text-xs hidden md:block font-mono px-3 py-1 rounded-full"
          style={isDark
            ? { color: 'var(--aqua)', background: 'var(--aqua-dim)', border: '1px solid var(--border)' }
            : { color: '#ffffff', background: 'var(--aqua)', border: 'none', fontWeight: 600 }
          }
        >
          {today}
        </span>

        {/* Theme toggle */}
        <button
          onClick={toggle}
          title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
          className="relative flex items-center rounded-full transition-all flex-shrink-0"
          style={{
            width: 52, height: 28,
            background: isDark ? 'rgba(0,255,240,0.12)' : 'rgba(0,168,158,0.12)',
            border: '1px solid var(--border-strong)',
            padding: 3,
          }}
        >
          <span
            className="flex items-center justify-center rounded-full text-xs transition-all duration-300"
            style={{
              width: 20, height: 20,
              background: 'var(--aqua)',
              transform: isDark ? 'translateX(0)' : 'translateX(24px)',
              color: isDark ? '#0E1623' : '#fff',
              fontSize: 11,
              boxShadow: '0 0 8px var(--aqua-glow)',
            }}
          >
            {isDark ? '🌙' : '☀️'}
          </span>
        </button>

        <button
          onClick={() => navigate('/settings')}
          className="flex items-center gap-2.5 px-3 py-1.5 rounded-xl transition-all"
          style={{ border: '1px solid var(--border)' }}
          onMouseEnter={e => e.currentTarget.style.borderColor='var(--border-strong)'}
          onMouseLeave={e => e.currentTarget.style.borderColor='var(--border)'}
        >
          <div
            className="w-7 h-7 rounded-lg flex items-center justify-center text-xs font-bold flex-shrink-0"
            style={{ background: 'var(--aqua)', color: isDark ? '#040810' : '#fff' }}
          >
            {owner?.name?.charAt(0)?.toUpperCase() || 'O'}
          </div>
          <div className="hidden sm:block text-left">
            <p className="text-xs font-semibold leading-tight" style={{ color: 'var(--text)' }}>
              {owner?.name || 'Owner'}
            </p>
            <p className="text-xs" style={{ color: 'var(--text-muted)' }}>Settings</p>
          </div>
        </button>
      </div>
    </header>
  );
}

export default Navbar;
